export default __webpack_public_path__ + "5b9af067985aa0d87c88d981e2e04f0f.png";